import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { Column } from "@pufflig/prompt-studio-types";
import { useEffect, useState } from "react";

interface EditColumnModalProps {
  isOpen: boolean;
  onClose: () => void;
  column: Column | null;
  onSave: (column: Column) => void;
}

export const EditColumnModal = ({ isOpen, onClose, column, onSave }: EditColumnModalProps) => {
  const [description, setDescription] = useState("");
  const [dataType, setDataType] = useState("");
  const [examples, setExamples] = useState("");
  const [synonyms, setSynonyms] = useState("");

  useEffect(() => {
    setDescription(column?.columnDescription || "");
    setDataType(column?.dataType || "");
    setExamples((column?.examples || []).join(", "));
    setSynonyms((column?.synonyms || []).join(", "));
  }, [column]);

  const handleSave = () => {
    if (!column) return;
    const updated: Column = {
      ...column,
      columnDescription: description,
      dataType,
      examples: examples
        .split(",")
        .map((e) => e.trim())
        .filter(Boolean),
      synonyms: synonyms
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean),
    };
    onSave(updated);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Text textStyle="heading/3/medium">Edit Column</Text>
          <ModalCloseButton />
        </ModalHeader>
        <ModalBody>
          <Stack gap="spacing-lg">
            <FormControl>
              <FormLabel>Column name</FormLabel>
              <Input value={column?.columnName || ""} isDisabled size="lg" />
            </FormControl>
            <FormControl>
              <FormLabel>Description</FormLabel>
              <Textarea size="lg" value={description} onChange={(e) => setDescription(e.target.value)} />
            </FormControl>
            <FormControl>
              <FormLabel>Data type</FormLabel>
              <Input isDisabled size="lg" value={dataType} onChange={(e) => setDataType(e.target.value)} />
            </FormControl>
            <FormControl>
              <FormLabel>Example values</FormLabel>
              <Input
                size="lg"
                placeholder="comma separated"
                value={examples}
                onChange={(e) => setExamples(e.target.value)}
              />
            </FormControl>
            <FormControl>
              <FormLabel>Synonyms</FormLabel>
              <Input
                size="lg"
                placeholder="comma separated"
                value={synonyms}
                onChange={(e) => setSynonyms(e.target.value)}
              />
            </FormControl>
          </Stack>
        </ModalBody>
        <ModalFooter>
          <Stack direction="row" gap="1">
            <Button variant="ghost" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSave}>
              Save
            </Button>
          </Stack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
